import { ErrorHandler, Injectable } from '@angular/core';
import { ListFactory } from '../../caches/list.factory';

/**
 * GlobalErrorHandler is used to implement global type errors.
 */
@Injectable(
    {
        providedIn:'root'
    }
)
export class GlobalExceptionHandler implements ErrorHandler {
    listFactory: ListFactory;

    constructor() {
        this.listFactory = ListFactory.getInstance();
    }

    /**
     * handleError() method will be triggered when any exception is raised anywhere in the application.
     */
    handleError(error: any): void {
        // console.error(error);
        // this.listFactory.globalErrorHandlerPopupId.show(error);
    }
} 